import React, { Component } from "react";
import { Link } from "react-router-dom";
import Menu from "./components/menu";
import Header from "../../layout/header";
import Footer from "../../layout/footer";
const bg = require("../../../images/servicehero.png");

class AirbnbCleaning extends Component {
  // componentDidMount() {
  //   // Scroll to the top as soon as the component mounts
  //   window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  // }

  render() {
    return (
      <>
        <Header />
        <div className="page-content bg-white">
          <div
            className="dlab-bnr-inr bg-pt"
            style={{ backgroundImage: "url(" + bg + ")" }}
          >
            <div className="container">
              <div className="dlab-bnr-inr-entry">
                <h1 className="text-white">Airbnb Property Management </h1>
                <div className="breadcrumb-row">
                  {/* Breadcrumbs can be uncommented if needed */}
                </div>
              </div>
            </div>
          </div>

          <div className="content-block">
            <div className="section-full content-inner">
              <div className="container">
                <div className="row">
                  <Menu />
                  <div className="col-xl-9 col-lg-8 col-md-7 m-b30">
                    <div className="col-md-12 m-b30">
                      <div className="dlab-box">
                        {/* <div className="dlab-media">
                          <Link to="#">
                            <img
                              src={require("../../images/about/pic3.jpg")}
                              alt=""
                            />
                          </Link>
                        </div> */}
                        <div className="dlab-info ">
                          <h4 className="dlab-title m-t0">
                            <Link to="#">
                              Airbnb property management, cleaning and linen
                              services
                            </Link>
                          </h4>
                          <p>
                            At Kangaroo Shine Property Services, we take the
                            stress out of managing and maintaining your Airbnb
                            property. Serving Queensland, our experienced team
                            of property managers ensures your property is always
                            guest-ready, delivering top-notch cleaning and
                            seamless service. From routine cleaning to in-depth
                            deep cleans between bookings, we guarantee your
                            property will exceed guest expectations for
                            cleanliness and comfort—helping you earn higher
                            ratings and more revenue.
                          </p>
                        </div>
                        <div className="dlab-info m-t30 ">
                          <h4 className="dlab-title m-t0">
                            <Link to="#">Airbnb management and cleaning</Link>
                          </h4>
                          <p>
                            We offer a complete Airbnb management solution,
                            which includes hassle-free cleaning at no additional
                            cost to you. The Airbnb cleaning fee covers all
                            housekeeping expenses, so you won’t need to worry
                            about hidden costs or juggling cleaning schedules.
                            Our expert team will ensure your property is
                            impeccably cleaned and maintained after every guest,
                            giving you the peace of mind to focus on
                            growing your business.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="dlab-box">
                      <div className="dlab-info m-t30">
                        <h4 className="dlab-title m-t0 p-b2">
                          <Link to="#">Linen replacement services</Link>
                        </h4>
                        <p>
                          Tired of the laundry chaos between guest stays? Our
                          linen replacement service takes care of it for you. As
                          part of our streamlined cleaning process, we’ll handle
                          changing and laundering all the linens—ensuring fresh,
                          high-quality bedding and towels for each new guest.
                          With Kangaroo Shine, you’ll never have to delay
                          check-ins or worry about the linens. We provide
                          top-tier, comfy linens that your guests will love, so
                          they can settle in and enjoy their stay from the
                          moment they arrive.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

export default AirbnbCleaning;
